import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '@core/store';

interface AdminGuardProps {
    children: ReactNode;
}

/**
 * Admin Guard Component
 *
 * Protects routes that require admin authentication.
 * Redirects non-admin users to the admin login page.
 */
export function AdminGuard({ children }: AdminGuardProps) {
    const location = useLocation();
    const { isAdminAuthenticated, isLoading } = useAppSelector((state) => state.auth);

    // Show nothing while checking auth state
    if (isLoading) {
        return null;
    }

    // Redirect to admin login if not authenticated as admin
    if (!isAdminAuthenticated) {
        return <Navigate to="/dashboard/admin-login" state={{ from: location }} replace />;
    }

    return <>{children}</>;
}

export default AdminGuard;
